import type {
  MonitorIoTClass,
  MonitorType,
} from "@/services/backend/qpm/types/enums";

export interface RequirementMonitorSummaryItemDTO {
  monitorId: string;
  monitorTypeKey: MonitorType;
  iotClass?: MonitorIoTClass;
  hasLethalAgent: boolean;
  totalAmount: number;
  totalInstallationTime: number;
  totalServiceTime: number;
  basePrice: number;
  totalPrice: number;
}

export interface RequirementMonitorSummaryDTO {
  monitors: RequirementMonitorSummaryItemDTO[];
  typeSummary: TypeSummaryItemDTO[];
  totalInstallationTime: number;
  totalServiceTime: number;
  totalPrice?: number;
}

export interface TypeSummaryItemDTO {
  monitorType: MonitorType;
  iotClass?: MonitorIoTClass;
  amount: number;
}

export function getTypeSummaryAmount(
  typeSummary: TypeSummaryItemDTO[],
  monitorTypeKey: MonitorType,
  iotClass?: MonitorIoTClass,
): number {
  const typeSummaryItem = typeSummary.find((item) => {
    // Backend payload uses `type`, DTO expects `monitorType`
    const itemType =
      (item as unknown as { type?: MonitorType }).type ?? item.monitorType;

    if (itemType !== monitorTypeKey) return false;

    // Treat `undefined` / `null` IoT class as a wildcard when caller doesn't provide `iotClass`
    if (iotClass == null) return true;

    return item.iotClass === iotClass;
  });

  return typeSummaryItem ? typeSummaryItem.amount : 0;
}
